export default __webpack_public_path__ + "static/media/acceptedCards.f46b39cb.png";